export default "__VITE_ASSET__75c71e5a__"